import script from "./ListCampaignsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListCampaignsPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__